/**
 * Scrolls the window/document and every vertical scrollable ancestor of `origin` to top.
 * eCargo `Sidebar` uses an inner `overflow-y: auto` region — `window.scrollTo` alone does not move it.
 */
export function scrollViewportAndAncestorsToTop(origin: HTMLElement | null): void {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    let el: HTMLElement | null = origin;
    while (el) {
        const { overflowY } = getComputedStyle(el);
        if (/(auto|scroll|overlay)/.test(overflowY)) {
            el.scrollTop = 0;
        }
        el = el.parentElement;
    }
}
